import { render, staticRenderFns } from "./Suscriptions.vue?vue&type=template&id=2e222042&scoped=true"
import script from "./Suscriptions.vue?vue&type=script&lang=js"
export * from "./Suscriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e222042",
  null
  
)

export default component.exports